import $ from 'jquery';
import { MindboxCarousel } from './mindbox-carousel';

export class MindboxProductsRecommendations {
    constructor() {
        this.container = $('[data-mindbox-product="personal"]');
    }

    init() {
        if (this.container.length === 0) {
            return;
        }

        let _self = this;
        $.ajax({
            url: '/ajax/action/widget_mindbox_products/get_personal_products/',
            type: 'GET',
            success: function(result) {
                console.log(result);
                if (result.data.status !== 'ok') {
                    console.log('mindbox box not render');
                    return;
                }

                _self.container.html(result.html);
                MindboxCarousel.init();
            }
        });
    }
}
jQuery(function() {
    new MindboxProductsRecommendations().init();
});



// WEBPACK FOOTER //
// ./modules/mindbox/mindbox-products-recommendations.js